import { alpha, luminance, mix } from "@/common/lib/color";

export function getButtonStyle(buttonStyle, colors) {
    const { background, emphasis, text } = colors;
    const contrast = luminance(emphasis) > 0.6 ? "#141210" : "#FFFFFF";
    const filled = { background: emphasis, color: contrast };

    switch (buttonStyle) {
        case "pill":
            return { ...filled, borderRadius: "999px" };
        case "square":
            return { ...filled, borderRadius: "0" };
        case "outline":
            return {
                background: "transparent",
                color: emphasis,
                border: `2px solid ${emphasis}`,
                borderRadius: "9px"
            };
        case "shadow":
            return {
                ...filled,
                borderRadius: "10px",
                boxShadow: `0 4px 0 0 ${mix(
                    emphasis,
                    "#000000",
                    0.75
                )}, 0 6px 10px ${alpha(emphasis, 0.3)}`
            };
        case "gradient":
            return {
                color: contrast,
                borderRadius: "10px",
                background: `linear-gradient(135deg, ${emphasis}, ${mix(
                    emphasis,
                    "#FFFFFF",
                    0.75
                )})`,
                boxShadow: `0 5px 12px ${alpha(emphasis, 0.3)}`
            };
        case "neumorphic": {
            const dark = luminance(background) < 0.42;
            const elevated = dark
                ? mix("#FFFFFF", background, 0.07)
                : mix("#FFFFFF", background, 0.72);
            const highlight = dark
                ? "rgba(255, 255, 255, 0.06)"
                : "rgba(255, 255, 255, 0.65)";
            return {
                background: elevated,
                color: emphasis,
                borderRadius: "12px",
                boxShadow: `4px 4px 8px ${alpha(
                    text,
                    0.18
                )}, -4px -4px 8px ${highlight}`
            };
        }
        case "glass": {
            const dark = luminance(background) < 0.42;
            const elevated = dark
                ? mix("#FFFFFF", background, 0.07)
                : mix("#FFFFFF", background, 0.72);
            return {
                background: alpha(elevated, 0.35),
                color: text,
                border: `1px solid ${alpha(text, 0.2)}`,
                borderRadius: "12px",
                backdropFilter: "blur(10px)"
            };
        }
        case "rounded":
        default:
            return { ...filled, borderRadius: "10px" };
    }
}

export function getCardShapeStyle(buttonStyle, colors) {
    const { background, emphasis, text } = colors;

    switch (buttonStyle) {
        case "pill":
            return { borderRadius: "20px" };
        case "square":
            return { borderRadius: "0" };
        case "outline":
            return { borderRadius: "12px", border: `2px solid ${emphasis}` };
        case "shadow":
            return {
                borderRadius: "10px",
                boxShadow: `0 6px 0 0 ${mix(
                    emphasis,
                    "#000000",
                    0.75
                )}, 0 8px 14px ${alpha(emphasis, 0.3)}`
            };
        case "gradient":
            return {
                borderRadius: "10px",
                boxShadow: `0 8px 20px ${alpha(emphasis, 0.3)}`
            };
        case "neumorphic": {
            const dark = luminance(background) < 0.42;
            const highlight = dark
                ? "rgba(255, 255, 255, 0.06)"
                : "rgba(255, 255, 255, 0.65)";
            return {
                borderRadius: "16px",
                boxShadow: `6px 6px 12px ${alpha(
                    text,
                    dark ? 0.4 : 0.18
                )}, -6px -6px 12px ${highlight}`
            };
        }
        case "glass":
            return {
                borderRadius: "16px",
                border: `1px solid ${alpha(text, 0.2)}`
            };
        case "rounded":
        default:
            return { borderRadius: "10px" };
    }
}
